/* eslint-disable */
import xhr from '@/xhr';

const parseDom = (str) => {
  const dom = document.createElement('div');
  dom.innerHTML = str;
  return dom.childNodes;
};

//礼物动画
var giftAnimationObject = process.browser ? {
  giftInit: async function() {
    // fix: 送礼动画无法触发的问题
    this.giftAnimationTag = document.querySelector('#gift_animation_e');
    this.screenGiftAnimationTag = document.querySelector('#screen_gift_tag_e');

    // fix: 前端路由进入另一个房间的时候，送礼动画队列重新初始化，且不需要再请求礼物接口
    if (this.giftJSONLikeArr.length > 0) {
      this.screenGiftWaiting.length = 0;
      this.screenGiftDisplaying.length = 0;
      this.giftWaiting.length = 0;
      this.giftDisplaying.length = 0;
      return;
    };
  
    const res = await xhr.post(`${process.env.baseUrl}/live/giftconfig/getOnlineGifts`);
    const giftJSONLikeArr = res?.data || [];
    if (giftJSONLikeArr) {
      this.giftJSONLikeArr = giftJSONLikeArr;
      window.giftJSONLikeArr = giftJSONLikeArr;
    }

    const res2 = await xhr.get(`${process.env.baseUrl}/screengift/giftjson`);
    const screenGiftJSON = res2?.data || [];
    if (screenGiftJSON) {
      this.screenGiftJSON = screenGiftJSON;
    }
    this.cacheScreenResources(this.screenGiftJSON);
  },
  giftJSONLikeArr: [],
  giftAnimationTag: document.querySelector('#gift_animation_e'),
  screenGiftJSON: [],
  screenGiftAnimationTag: document.querySelector('#screen_gift_tag_e'),
  ResourcesOfScreen: [], //缓存下来的爆屏礼物资源
  webpSupport: 'png_url',
  screenGiftWaiting: [],
  screenGiftDisplaying: [],
  cacheScreenResources: function(data) {
    if (window.navigator.userAgent.match(/.*Mobile.*/)) return;

    var len = data.length;
    var ResourcesOfScreen = this.ResourcesOfScreen;
    var image = null;
    /*try{
        this.webpSupport = (document.createElement('canvas').toDataURL('image/webp').indexOf('data:image/webp') == 0) === true?'webp_url':'png_url';
    }catch(e){
        this.webpSupport = 'png_url';
    }*/
    for (var i = 0; i < len; i++) {
      image = new Image();
      if (window.location.origin.includes('bigoapp.tv')) {
        data[i][this.webpSupport] = data[i][this.webpSupport].replace('gdl.bigo.sg', 'gdl.piojm.tech');
      }
      ResourcesOfScreen[i] = image.src = data[i][this.webpSupport];
    }
  },
  fullScreenGiftAnimation: function(giftJsonMsg) {
    const screenGiftId = giftJsonMsg.vgift_typeid;
    var screenGift = this.getScreenGiftById(screenGiftId);
    // 如果送了爆屏动画列表里没有的爆屏，就显示普通的送礼动画
    if (!screenGift) {
      this.pushMsgToQueues(giftJsonMsg);
      return;
    }
    if (this.screenGiftDisplaying.length > 0) {
      this.screenGiftWaiting.push(screenGift);
    } else {
      // this.screenGiftDisplaying.push(screenGift);
      this.fullScreenAnimationDo(screenGift);
    }
  },
  fullScreenAnimationDo: function(screenGift) {
    var screenGift = screenGift;
    var screenGiftK = screenGift.height / screenGift.width;
    var BDM = window.danmu;
    var i = 0;
    if (screenGiftK > BDM.danMuHeight / BDM.danMuWidth) {
      screenGift.height =
        BDM.danMuHeight * 0.8 > screenGift.height
          ? screenGift.height
          : BDM.danMuHeight * 0.8;
      screenGift.width = screenGift.height / screenGiftK;
    } else {
      screenGift.width =
        BDM.danMuWidth * 0.8 > screenGift.width
          ? screenGift.width
          : BDM.danMuWidth * 0.8;
      screenGift.height = screenGift.width * screenGiftK;
    }
    this.screenGiftDisplaying.push(screenGift);
    // this.screenGiftAnimationTag.css({
    //   width: this.screenGiftDisplaying[0].width,
    //   height: this.screenGiftDisplaying[0].height,
    //   'background-image':
    //     'url(' + this.screenGiftDisplaying[0][this.webpSupport] + ')'
    // });
    this.screenGiftAnimationTag.style.width = this.screenGiftDisplaying[0].width + 'px';
    this.screenGiftAnimationTag.style.height = this.screenGiftDisplaying[0].height + 'px';
    this.screenGiftAnimationTag.style.backgroundImage = 'url(' + this.screenGiftDisplaying[0][this.webpSupport] + ')';
    if (this.webpSupport === 'png_url') {
      for (i = 0; i < screenGift.frame; i++) {
        setTimeout(
          (function(tag, height, i) {
            return function() {
              // tag.css('background-position', '0 -' + i * height + 'px');
              tag.style.backgroundPosition = '0 -' + i * height + 'px';
            };
          })(this.screenGiftAnimationTag, screenGift.height, i),
          100 * i
        );
      }
    }
    setTimeout(
      (function(that, tag) {
        return function() {
          // tag.css({
          //   'background-image': 'url(' + tag.attr('src') + ')',
          //   'background-position': '0 0'
          // });
          tag.style.backgroundImage = 'url(' + tag.src + ')';
          tag.style.backgroundPosition = '0 0';
          that.fullScreenClearAndAddNew();
        };
      })(this, this.screenGiftAnimationTag),
      screenGift.settleTime
    );
  },
  fullScreenClearAndAddNew: function() {
    this.screenGiftDisplaying[0] = null;
    this.screenGiftDisplaying.pop();
    if (this.screenGiftWaiting.length > 0) {
      this.fullScreenAnimationDo(this.screenGiftWaiting.shift());
    }
  },
  getScreenGiftById: function(screenGiftId) {
    var screenGiftJSON = this.screenGiftJSON;
    for (var i = 0, len = screenGiftJSON.length; i < len; i++) {
      if (+screenGiftJSON[i]['typeid'] === +screenGiftId) {
        return screenGiftJSON[i];
      }
    }
  },
  giftView:
    '<li class="gift_list"><div class="movingLight_box"><img class="movingLight" src="https://www.bigo.tv/assets/officialWeb/images/giftbg/combobg4.png"></div><div class="thumb"><img src="==="></div><p class="name">===</p><p class="send_tips">Send</p><div class="gift_star_box"><p class="gift_star star==="></p></div><img class="gift_icon" src="==="><div class="combo_box"><p class="x_num">x===</p><p class="tips">combo</p></div><div class="combo_counter">===</div><div class="gift_dressup dressupStatu==="></div></li>',
  giftWaiting: [],
  giftDisplaying: [],
  giftAnimationStart: function(msg) {
    var giftJsonMsg = msg;
    /*该次礼物在礼物配置中的序列位置*/
    var giftIndex = this.getGiftInforIndex(giftJsonMsg.vgift_typeid);
    var userUid = ''; //鉴别连续送礼叠加到队列中哪一个
    var giftId = 0;
    if (+giftJsonMsg.send_times === 1) {
      /*第一次的礼物*/
      if (this.giftJSONLikeArr[giftIndex]['vm_exchange_rate'] / 100 > 998) {
        this.fullScreenGiftAnimation(giftJsonMsg);
      } else {
        this.pushMsgToQueues(giftJsonMsg); //加入礼物动画队列
      }
    } else {
      //属于combo连续礼物
      if (+giftJsonMsg.vgift_count > 98) {
        //99或者以上combo礼物，从新刷一条消息
        this.pushMsgToQueues(giftJsonMsg); //加入礼物动画队列
      } else {
        userUid = giftJsonMsg.from_uid;
        giftId = giftJsonMsg.vgift_typeid;
        // 找到combo那个礼物，更新times,
        if (this.updateComboTimes(userUid, giftId, giftJsonMsg.send_times)) {
          // 返回1，表示没找到，进房间之前礼物已经处于combo状态
          this.pushMsgToQueues(giftJsonMsg);
        }
      }
    }
  },
  pushMsgToQueues: function(giftJsonMsg) {
    var giftJsonMsg = giftJsonMsg;
    if (this.giftDisplaying.length < 2) {
      //直接加入执行
      this.pushMsgToDisplaying(giftJsonMsg);
    } else {
      giftJsonMsg.fromWaitingQueues = true; //从等待队列中扒如执行队列，有一个特殊标记
      this.giftWaiting.push(giftJsonMsg); //加入等待队列
    }
  },
  pushMsgToDisplaying: function(jsonMsg) {
    var bottom = 0;
    var obj = {};
    var giftJsonMsg = jsonMsg;
    var str = '';
    var giftJson = {};
    var giftBackgroundLen = 0; //礼物的背景帧数组
    var that = this;
    if (this.giftDisplaying.length === 0) {
      bottom = 50;
    } else {
      for (var i = 0; i < 2; i++) {
        for (var j = 0; j < this.giftDisplaying.length; j++) {
          if (this.giftDisplaying[j]['bottom'] != 50 + 80 * i) {
            bottom = 50 + 80 * i;
          }
        }
      }
    }
    obj.from = giftJsonMsg.from_uid;
    obj.times = +giftJsonMsg.send_times;
    obj.currentTimes = 1; //当前显示的times
    if (
      +giftJsonMsg.vgift_count > 98 ||
      (+giftJsonMsg.times > 1 && !giftJsonMsg.fromWaitingQueues)
    ) {
      // 基数大于98重刷一条，中途进房间，一开始加入队列times大于1
      obj.currentTimes = +giftJsonMsg.send_times; //当前显示的times
    }
    obj.bottom = bottom;
    obj.comboClearCounter = 0;
    obj.giftId = giftJsonMsg.vgift_typeid;
    obj.baseXNum = +giftJsonMsg.vgift_count;
    giftJson = this.giftJSONLikeArr[this.getGiftInforIndex(giftJsonMsg.vgift_typeid)]; //当前礼物属性
    if (window.location.origin.includes('bigoapp.tv')) {
      giftJson.img_url = giftJson.img_url && giftJson.img_url.replace('giftesx.bigo.sg', 'giftesx.piojm.tech');
    }
    str = this.giftView
      .replace('===', giftJsonMsg.head_icon_url)
      .replace('===', giftJsonMsg.vgift_name)
      .replace('===', this.getGiftStar(giftJson))
      .replace('===', giftJson.img_url)
      .replace('===', giftJsonMsg.vgift_count)
      .replace('===', obj.currentTimes)
      .replace('===', this.returnGiftDressupBg(obj));
    const giftDomObj = parseDom(str)[0];
    // obj.giftDomTag = giftDomObj;
    obj.giftDomTag = giftDomObj;
    
    this.giftAnimationTag.appendChild(giftDomObj);
    obj.checkTimes = this.checkTimes;
    obj.scaleCombo = this.scaleCombo;
    obj.returnComboBgPosY = this.returnComboBgPosY;
    obj.checkTimes();
    setTimeout(
      (function(giftDomObj, bottom) {
        return function() {
          // giftDomObj.css({
          //   right: '40px',
          //   bottom: bottom
          // });
          giftDomObj.style.right = '40px';
          giftDomObj.style.bottom = bottom + 'px';
        };
      })(giftDomObj, bottom),
      20
    ); //礼物消息出现
    giftBackgroundLen = this.getGiftBackground(+giftJsonMsg.vgift_count);
    for (var k = 0; k < giftBackgroundLen; k++) {
      setTimeout(
        (function(giftDomObj, that, k) {
          return function() {
            var pos = '0px -' + k * 73 + 'px';
            // giftDomObj.css('background-position', pos);
            giftDomObj.style.backgroundPosition = pos;
          };
        })(giftDomObj, that, k),
        k * 100 + 400
      );
    } //礼物消息背景帧动画
    this.giftDisplaying.push(obj); //
  },
  checkTimes: function() {
    var allTimes = this.times;
    var currentTimes = this.currentTimes;
    if (currentTimes < allTimes) {
      this.currentTimes++;
      clearTimeout(this.comboClearCounter);
      this.comboClearCounter = 0;
      this.scaleCombo();
    } else {
      if (this.comboClearCounter === 0) {
        var countdown = giftAnimationObject.timeOfClearGift(this)-800;
        this.comboClearCounter = setTimeout((function(giftDisplayingObj){
            return function(){
                giftAnimationObject.clearGiftWhoTimeout(giftDisplayingObj);
            }
        })(this), countdown);//自检时间误差
      }
      // this.clearGiftTimer = setTimeout(, time);
    }
    setTimeout(
      (function(that) {
        return function() {
          try {
            that.checkTimes();
          } catch (e) {} /*删除之前，会有一次执行报错，所以try.*/
        };
      })(this), 800);
  },
  timeOfClearGift: function(giftDisplayingObj) {
    var id = giftDisplayingObj.giftId;
    var baseXNum = giftDisplayingObj.baseXNum;
    var times = giftDisplayingObj.times;
    var unitPrice = 1; //礼物单价
    if (baseXNum > 98) {
      times = 1;
    }
    unitPrice = this.giftJSONLikeArr[this.getGiftInforIndex(id)].vm_exchange_rate / 100;
    var value = this.getGiftShowTimeByCost(unitPrice*baseXNum)
    return value;
  },
  clearGiftWhoTimeout: function(giftDisplayingObj) {
    var from = giftDisplayingObj.from;
    var giftId = giftDisplayingObj.giftId;
    var currentTimes = giftDisplayingObj.currentTimes;
    var giftDisplaying = this.giftDisplaying;
    var that = this;
    var timeStamp = (+new Date()).toString().slice(-4);
    // giftDisplayingObj.giftDomTag
    //   .addClass('clearStatu' + timeStamp)
    //   .css('right', '-310px');
    giftDisplayingObj.giftDomTag.classList.add('clearStatu' + timeStamp);
    giftDisplayingObj.giftDomTag.style.right = '-310px';
    for (var i = 0; i < giftDisplaying.length; i++) {
      if (
        giftDisplaying[i].from === from &&
        giftDisplaying[i].giftId === giftId &&
        giftDisplaying[i].currentTimes === currentTimes
      ) {
        this.giftDisplaying[i].checkTimes = null;
        this.giftDisplaying[i] = null;
        this.giftDisplaying.splice(i, 1);
        i--;
        break;
      }
    } //找到送礼人uid，和礼物id。才能确定是否同一个礼物动画
    setTimeout(function() {
      // that.giftAnimationTag.find('.clearStatu' + timeStamp).remove();
      const removeDom = that.giftAnimationTag.querySelector(`.clearStatu${timeStamp}`);
      that.giftAnimationTag.removeChild(removeDom);
    }, 400);
    if (this.giftWaiting.length) {
      this.pushMsgToQueues(this.giftWaiting.pop()); //拉取等待位中最前的礼物进入执行列队
    }
  },
  returnGiftDressupBg: function(obj) {
    var baseXNum = obj.baseXNum;
    var dressupStatu = 0;
    if (baseXNum < 100) {
      if (baseXNum === 1) {
        dressupStatu = 0;
      } else if (baseXNum === 10) {
        dressupStatu = 1;
      } else {
        dressupStatu = 2;
      }
    } else {
      if (baseXNum === 188) {
        dressupStatu = 3;
      } else {
        dressupStatu = 4;
      }
    }
    return dressupStatu;
  },
  returnComboBgPosY: function(comboVal) {
    var comboPosY = 60;
    if (comboVal > 198) {
      if (comboVal > 519) {
        comboPosY = -180;
      } else {
        comboPosY = -120;
      }
    } else {
      if (comboVal > 65) {
        comboPosY = -60;
      } else if (comboVal > 10) {
        comboPosY = 0;
      } else {
        comboPosY = 60;
      }
    }
    return comboPosY;
  },
  // comboBackgroundPos:[40, 0, -40, -80, -120],
  clearTimeoutByGiftCosts: [3 * 1000, 4 * 1000, 5 * 1000, 6 * 1000, 7 * 1000],
  getGiftShowTimeByCost: function(allCosts) {
    var index = 0;
    if (allCosts > 99) {
      if (allCosts > 499) {
        index = 4;
      } else {
        index = 3;
      }
    } else {
      if (allCosts > 49) {
        index = 2;
      } else if (allCosts > 9) {
        index = 1;
      } else {
        index = 0;
      }
    }
    var value = this.clearTimeoutByGiftCosts[index]
    return value;
  },
  scaleCombo: function() {
    // var comboCounterTag = this.giftDomTag.find('.combo_counter');
    var comboCounterTag = this.giftDomTag.querySelector('.combo_counter');
    var bgPosY = this.returnComboBgPosY(this.currentTimes);
    // comboCounterTag.addClass('countAnimation').text(this.currentTimes);
    comboCounterTag.classList.add('countAnimation')
    comboCounterTag.innerText = this.currentTimes;
    setTimeout(
      (function(jqTag) {
        return function() {
          jqTag.classList.remove('countAnimation');

          // 找他对父元素，用父元素找movingLight
          // jqTag
          //   .siblings('.movingLight_box')
          //   .find('.movingLight')
          //   .removeClass('movingStatu');
        };
      })(comboCounterTag),
      600
    );
    for (var i = 0; i < 6; i++) {
      setTimeout(
        (function(comboCounterTag, bgPosY, i) {
          return function() {
            var pos = -i * 60 + 'px ' + bgPosY + 'px';
            comboCounterTag.style.backgroundPosition = -i * 60 + 'px ' + bgPosY + 'px';
            // comboCounterTag.css(
            //   'background-position',
            //   -i * 60 + 'px ' + bgPosY + 'px'
            // );
          };
        })(comboCounterTag, bgPosY, i),
        i * 120
      );
    }
    if (
      this.baseXNum === 10 ||
      (this.baseXNum === 1 && this.currentTimes % 10 === 0)
    ) {
      // comboCounterTag
      //   .siblings('.movingLight_box')
      //   .find('.movingLight')
      //   .addClass('movingStatu');
    }
  },
  getGiftBackground: function(giftCntBaseX) {
    var bgIndex = 0; //返回背景帧的条数
    switch (giftCntBaseX) {
      case 1:
        bgIndex = 0;
        break;
      case 10:
        bgIndex = 8;
        break;
      case 99:
        bgIndex = 17;
        break;
      case 188:
        bgIndex = 27;
        break;
      case 999:
        bgIndex = 41;
        break;
    }
    return bgIndex;
  },
  getGiftStar: function(giftJson) {
    var diamonds = giftJson.vm_exchange_rate / 100;
    var star = 1;
    if (diamonds < 50) {
      if (diamonds < 10) {
        star = 1;
      } else {
        star = 2;
      }
    } else {
      if (diamonds < 100) {
        star = 3;
      } else {
        star = 4;
      }
    }
    return star;
  },
  getGiftInforIndex: function(id) {
    var giftArr = this.giftJSONLikeArr;
    for (var i = 0, len = giftArr.length; i < len; i++) {
      if (+giftArr[i]['typeid'] === +id) {
        return i;
      }
    }
  },
  updateComboTimes: function(userUid, giftId, times) {
    for (var j = this.giftWaiting.length - 1; j > -1; j--) {
      if (
        +this.giftWaiting[j]['from'] === +userUid &&
        +this.giftWaiting[j]['id'] === +giftId
      ) {
        this.giftWaiting[j]['times'] = times;
        return 0;
      }
    }
    for (var i = this.giftDisplaying.length - 1; i > -1; i--) {
      if (
        +this.giftDisplaying[i]['from'] === +userUid &&
        +this.giftDisplaying[i]['giftId'] === +giftId
      ) {
        this.giftDisplaying[i]['times'] = times;
        return 0;
      }
    }
    return 1;
  }
} : {
  giftInit: function() {}
};

export default giftAnimationObject;
